const _BATTLECHECK = 5000;
const _STARTBATTLE = 1000;
const _FLIP = 1000;

Vue.component('battleArena', {
  template: templates.battleArena,
  data() {
    return {
      model: {
        id:  null,
        cards1: [],
        cards2: [],
        questCards: [],
        questUser: false,
        questUser2: false,
        index1: 0,
        index2: 0,
        user1Faction: null,
        user2Faction: null,
        multipleBattle: [],
        finalBattle: false,
        singleMode: true,
        isTournamentRoundInProgress: false,
        setUserData: false,
        currentUserId: null,
        user1: {
          twitchId: null,
          twitchDisplayName: null,
          twitchProfileImage: null
        },
        user2: {
          twitchId: null,
          twitchDisplayName: null,
          twitchProfileImage: null
        },
        team1: [],
        team2: [],
        team1winner: [],
        team2winner: [],
        battleLoaded: false,
        abilities: [],
        settings: {},
        stolenCard: null,
        show: {
          profile_intro: false,
          winner: false,
          cards: false,
          stolenCard: false,
          users: false,
          move: false,
          logs: true
        },
        audio: {},
        logs: [],
        events: [],
        tournament: [],
        isTournamentOpen: false,
        tournamentData: [],
        notification: {
          visible: false,
          message: '',
          type: 'info' // 'info', 'success', 'warning', 'error'
        },
        obsOverlay: {
          visible: false,
          toggleState: 'off', // 'on' or 'off' - identifier for toggle state
          mode: 'modal', // 'modal', 'side', 'bottom', 'fullscreen'
          battles: [],
          packs: [],
          allBattles: [], // Store raw data before filtering
          allPacks: [], // Store raw data before filtering
          overlayVisibility: 'all',
          connected: false,
          viewerPreference: 'all', // 'all', 'mine', 'others' - viewer's preference
          streamerConfig: { // Streamer's base configuration
            packVisibility: 'all',
            battleVisibility: 'all'
          }
        }
      }
    }
  },
  created(){
    const c = this;
    c.model.currentUserId = utils.cookies.get('user_id');
    c.getActiveTournament();


    c.getSettings();
    c.setupSounds();
    c.connect();
  },
  mounted() {
    const c = this;
    // Initialize OBS overlay WebSocket connection
    c.connectObsWebSocket();
    // Load viewer's saved OBS preference from localStorage
    c.loadObsViewerPreference();

    // Expose trait damage floating number hook for traits.js
    window.battleUI = {
      showHpLost: function(card, damage, traitName) {
        const $card = $(`#${card.id}`);
        if (!$card.length) { return; }
        const $hpLost = $(`<span class="hp-lost trait-damage trait-dmg-${traitName}">-${damage}</span>`);
        $card.append($hpLost);
        setTimeout(function() { $hpLost.addClass('show'); }, 50);
        setTimeout(function() { $hpLost.addClass('remove'); }, 1300);
        setTimeout(function() { $hpLost.remove(); }, 4300);
      },
      showResourceLost: function(card, amount, type, delay) {
        const $card = $(`#${card.id}`);
        if (!$card.length) { return; }
        const d = delay || 0;
        const $indicator = $(`<span class="hp-lost resource-lost resource-lost-${type}">-${amount}</span>`);
        $card.append($indicator);
        setTimeout(function() { $indicator.addClass('show'); }, d + 50);
        setTimeout(function() { $indicator.addClass('remove'); }, d + 1300);
        setTimeout(function() { $indicator.remove(); }, d + 4300);
      }
    };
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          // Handle visibility changes
          if (data.message === 'visibilityChanged') {
            console.log('Visibility changed to:', data.newSetting);

            // Show notification
            const settingText = data.newSetting === 'all' ? '👁️ All Battles/Packs' : '🔒 Only My Battles/Packs';
            c.model.notification = {
              visible: true,
              message: `Stream visibility changed to: ${settingText}`,
              type: 'success'
            };

            // Auto-hide notification after 5 seconds
            setTimeout(() => {
              c.model.notification.visible = false;
            }, 5000);

            // Refresh battles with new visibility filter
            c.getBattles();
          }
        } catch (e) {
          console.error('Error parsing WebSocket message:', e);
        }
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    broadcastBattleStarted() {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const message = {
            message: 'battleStarted',
            channelId: c.model.currentUserId, // Use streamer/channel ID, not battler ID
            battleId: c.model.id,
            user1TwitchId: c.model.user1?.twitchId,
            user2TwitchId: c.model.user2?.twitchId,
            user1DisplayName: c.model.user1?.twitchDisplayName,
            user2DisplayName: c.model.user2?.twitchDisplayName,
            user1ProfileImage: c.model.user1?.twitchProfileImage,
            user2ProfileImage: c.model.user2?.twitchProfileImage,
            user1Cards: c.model.cards1,
            user2Cards: c.model.cards2,
            status: 'active',
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting battle started with full card data to channel:', c.model.currentUserId);
          ws.send(JSON.stringify(message));
          ws.close();
        };

        ws.onerror = (error) => {
          // WebSocket broadcast failed - not critical, OBS will update via polling
          console.log('WebSocket broadcast failed:', error);
        };

        ws.onclose = () => {
          // Connection closed
        };
      } catch (error) {
        // WebSocket unavailable - graceful degradation
        console.log('WebSocket unavailable for battle broadcast:', error);
      }
    },
    broadcastBattleWinner(winnerPlayer, winnerTwitchId, winnerDisplayName, winnerProfileImage) {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const message = {
            message: 'battleWinner',
            channelId: c.model.currentUserId, // Use streamer/channel ID, not battler ID
            battleId: c.model.id,
            winnerPlayer: winnerPlayer,
            winnerTwitchId: winnerTwitchId,
            winnerDisplayName: winnerDisplayName,
            winnerProfileImage: winnerProfileImage || '',
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting battle winner to channel:', c.model.currentUserId, 'Winner:', winnerDisplayName, 'Player:', winnerPlayer);
          ws.send(JSON.stringify(message));
          ws.close();
        };

        ws.onerror = (error) => {
          console.log('WebSocket winner broadcast failed:', error);
        };

        ws.onclose = () => {
          // Connection closed
        };
      } catch (error) {
        console.log('WebSocket unavailable for winner broadcast:', error);
      }
    },
    /**
     * Broadcast battle reset event via WebSocket
     * Called when the battle animation completes and resets
     */
    broadcastBattleReset() {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const message = {
            message: 'battleReset',
            channelId: c.model.currentUserId,
            battleId: c.model.id,
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting battle reset to channel:', c.model.currentUserId);
          ws.send(JSON.stringify(message));
          ws.close();
        };

        ws.onerror = (error) => {
          console.log('WebSocket reset broadcast failed:', error);
        };

        ws.onclose = () => {
          // Connection closed
        };
      } catch (error) {
        console.log('WebSocket unavailable for reset broadcast:', error);
      }
    },
    /**
     * Broadcast card flip event via WebSocket
     * Called when a card is flipped during battle
     */
    broadcastCardFlip(card, playerIndex) {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const message = {
            message: 'battleCardFlip',
            channelId: c.model.currentUserId,
            battleId: c.model.id,
            cardId: card.id,
            cardName: card.name,
            playerIndex: playerIndex,
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting card flip:', card.name);
          ws.send(JSON.stringify(message));
          ws.close();
        };

        ws.onerror = (error) => {
          console.log('WebSocket card flip broadcast failed:', error);
        };
      } catch (error) {
        console.log('WebSocket unavailable for card flip broadcast:', error);
      }
    },
    /**
     * Broadcast log message via WebSocket to extensions
     */
    broadcastLog(message) {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const data = {
            message: 'battleLog',
            channelId: c.model.currentUserId,
            battleId: c.model.id,
            logMessage: message,
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting log:', message);
          ws.send(JSON.stringify(data));
          ws.close();
        };

        ws.onerror = (error) => {
          console.log('WebSocket log broadcast failed:', error);
        };
      } catch (error) {
        console.log('WebSocket unavailable for log broadcast:', error);
      }
    },
    gridStyle(cardCount) {
      return {
          display: 'grid',
          gridTemplateColumns: `repeat(${cardCount}, 1fr)`,
          gap: '10px' // Optional: Add some space between cards
      };
    },
    getIndex(index) {
      return `quest-index-${index}`;
    },
    shouldShowBattle() {
      const c = this;
      // Get user's personal settings from localStorage
      const userSettings = {
        battleVisibility: localStorage.getItem('battleVisibility') || 'all',
        packVisibility: localStorage.getItem('packVisibility') || 'all'
      };

      // Build battle object from current model
      const battle = {
        user1TwitchId: c.model.user1?.twitchId,
        user2TwitchId: c.model.user2?.twitchId,
        user1: c.model.user1,
        user2: c.model.user2
      };

      // For dashboard view, only use user's personal settings
      return visibilityService.shouldShowBattle(
        battle,
        c.model.currentUserId,
        userSettings,
        null,
        'dashboard'
      );
    },
    stop() {
      const c = this;
      c.playerDefeated(1);
    },
    setupSounds() {
      const c = this;

      c.model.audio.hit = new Audio('../audio/hit.mp3');
      c.model.audio.flip = new Audio('../audio/card-flip.mp3');
      c.model.audio.move = new Audio('../audio/whoosh-02.mp3');
      c.model.audio.win = new Audio('../audio/award-01.mp3');
      c.model.audio.pop = new Audio('../audio/pop.mp3');
      c.model.audio.reward = new Audio('../audio/reward.mp3');
    },
    getSettings() {
      const c = this;
      
      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          
        })
        .catch(function (error) {
          
        });

    },
    getActiveTournament(){
      const c = this;

      tournamentService.getActive()
      .then((res) => {

        console.log(res)
     
          if(res.data.status===400){
           c.model.isTournamentOpen = false;
           c.getAbilities();
          }
          else{
            c.model.tournament = res.data[0];  
            c.model.isTournamentOpen = true;
            c.getAbilities();
          }

      })
      .catch((error) => {
        // console.log(error);
      });
    },
    stupidLog(message) {
      $('.stupid-log').prepend(`<p>${message}</p>`);
    },
    getAbilities() {
      const c = this;
      let data = {};
      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }

          c.model.abilities = data;
          c.getTraitsFromDb();
        })
        .catch(function (error) {
          getAbilities();
        });
    },
    getTraitsFromDb() {
      const c = this;
      traitService.get()
        .then(function (response) {
          if (window.traits) { traits.loadFromDb(response.data); }
          c.getBattles();
        })
        .catch(function () {
          c.getBattles();
        });
    },
    getStatus() {
      const c = this;

      battleService.getStatus(c.model.id)
        .then(function (response) {
          if (response.data.deleted || response.data.queue) {
            // window.location.reload();
          }
        
          setTimeout(function() {
            c.getStatus();
          }, 4000);
        })
        .catch(function (error) {
          
        });
    },
    getBattles() {
      const c = this;

      //Prevent calling api while a battle is happening
      if (c.model.battleLoaded) {
        return;
      }
    
      if(c.model.isTournamentOpen === true){

        // if(c.model.tournament.battleOption !== 'single'){
   
        //   teamBattleService
        //   .getActive()
        //   .then(function (response) {
        //     let data = response.data[0];
        //     // console.log(data.id);
   

        //       c.model.battleLoaded = true;
        //       c.processTeamBattle(data);
        
        //       // c.getTwitchUsers();
               
        //   })
        //   .catch(function (error) {
        //     setTimeout(function () {
        //       c.getBattles();
        //     }, _BATTLECHECK);
        //   });
        // }
 
          //Get active battle
          battleService.getActiveTournament()
          .then(function (response) {
            let data = response.data;

  
              c.model.battleLoaded = true;

              c.model.tournamentData.round = data[0].round;
              c.model.tournamentData.index = data[0].index;
              c.model.tournamentData.bracket = data[0].bracket;
              c.model.tournamentData.tournamentTeamUsed = data[0].tournamentTeamUsed;
              if(c.model.tournament.battleOption !== 'single'){
                c.processTeamBattle(data);
             
              }
              else{
                if(c.model.tournament.multiple){
                  c.processTeamBattle(data);
                }
                else{
                  c.processBattle(data[0])
                }

              }
         
              // c.getTwitchUsers()

          })
          .catch(function (error) {
            setTimeout(function() {
              c.getBattles();
            }, _BATTLECHECK);
          });
      

      }
      else{
        if (c.model.settings.autobattle && c.model.settings.autobattle.value) {
          //Get active battle
          c.getAutoBattle();
          
        } else {
          c.getActiveBattle();
        }

      }

      //TODO refactor this at some point
    
     
    },
    getAutoBattle(){
      const c = this;
      battleService.getAuto()
      .then(function (response) {
        let data = response.data[0];

        if (c.model.id != data.id) {
          c.model.battleLoaded = true;

          if(data.type === 'single'){
            c.processBattle(data);
            c.getTwitchUsers()
    
           }
           else{
            c.processTeamBattle(data)
           }

        }

      })
      .catch(function (error) {
        setTimeout(function() {
          c.getBattles();
        }, _BATTLECHECK);
      });
    },
    getActiveBattle(){
      const c = this;
       //Get active battle
       battleService.getActive()
       .then(function (response) {
         let data = response.data[0];
         if (c.model.id != data.id) {
           c.model.battleLoaded = true;

           if(data.mode === 'single'){
            c.processBattle(data);
            c.getTwitchUsers()
   
           }
           else{
            c.processTeamBattle(response.data)
            console.log(c.model)
           }
    
         }

       })
       .catch(function (error) {
         setTimeout(function() {
           c.getBattles();
         }, _BATTLECHECK);
       });
    },
    //Add cards to model and get twitch info
    processBattle(data) {
      const c = this;
      c.model.id = data.id;

      c.model.tournamentData.round = data.round;
      c.model.tournamentData.index = data.index;
      c.model.tournamentData.bracket = data.bracket;
      c.model.tournamentData.tournamentTeamUsed = data.tournamentTeamUsed;

      // c.getStatus();

      let cards1 = playingCards.getCardsStats(data.user1Cards, c.model.abilities);
      let cards2 = playingCards.getCardsStats(data.user2Cards, c.model.abilities);

      c.model.cards1 = cards1;
      c.model.cards2 = cards2;


      c.model.user1Faction = data.user1Faction;
      c.model.user2Faction = data.user2Faction;
      
      c.getTwitchInfo(data);
     
    },
    processTeamBattle(data){
      const c = this;
      c.model.multipleBattle = data;
      c.model.id = data[0].id;
      console.log(c.model)
      if(data[0].user1Faction && data[0].user2Faction){
        c.model.user1Faction = data[0].user1Faction;
        c.model.user2Faction = data[0].user2Faction;
      }
      else{
        c.model.user1Faction = data[0].team1faction;
        c.model.user2Faction = data[0].team2faction;
      }
     
      if(c.model.tournament.battleOption === 'single'){
    
        for(i=0;i<data.length;i++){

          let user1 = {
            "active": data[i].active,
            "id": data[i].id,
            "tournamentId": data[i].tournamentId,
            "bracket": data[i].bracket,
            "round": data[i].round,
            "bracketIndex": data[i].index,
            "index": 0,
            "user": data[i].twitch1DisplayName[0],
            "tournamentTeamUsed": data[i].tournamentTeamUsed,
            "factionId": data[i].user1Faction,
            "cards": playingCards.getCardsStats(data[i].user1Cards, c.model.abilities),
          }
  
          let user2 = {
            "active": data[i].active,
            "id": data[i].id,
            "tournamentId": data[i].tournamentId,
            "bracket": data[i].bracket,
            "round": data[i].round,
            "bracketIndex": data[i].index,
            "index": 0,
            "user": data[i].twitch2DisplayName[0],
            "tournamentTeamUsed": data[i].tournamentTeamUsed,
            "factionId": data[i].user2Faction,
            "cards": playingCards.getCardsStats(data[i].user2Cards, c.model.abilities),
          }
  
          c.model.team1.push(user1);
          c.model.team2.push(user2);
        }


        if(c.model.team1.length > 1 && c.model.team2.length > 1){

          c.model.singleMode = false
          c.model.setUserData =  true;
          
          setTimeout(function () {
            c.startTournamentBattle();
          }, _STARTBATTLE);

        }
        else{
          let cards1 = playingCards.getCardsStats(data[0].user1Cards, c.model.abilities);
          let cards2 = playingCards.getCardsStats(data[0].user2Cards, c.model.abilities);
          c.model.cards1 = cards1;
          c.model.cards2 = cards2;
          c.getTwitchInfo(data[0]);
        }


      }
      else{
        c.model.singleMode = false
        c.setUpTeamBattle(data[0])
      }
  
      // if(c.model.team1.length > 1 && c.model.team2.length > 1){
  
  
      // }
      // else{
      //   if (c.model.settings.autobattle && c.model.settings.autobattle.value) {
      //     //Get active battle
      //     c.getAutoBattle();
      //   } else {
      //     c.getActiveBattle();
      //   }
      // }

   

    },
    async setUpTeamBattle(data) {
      const c = this;

      c.model.type = data.type;
      c.model.id = data.id;
      c.model.setUserData =  true;

      c.model.streamer1 = data.streamerChallenge;
      c.model.streamer2 = data.streamerAccept;

      if(data.mode === 'team'){
        const team1 = data.team1.sort((a, b) => new Date(a.date) - new Date(b.date));
        const team2 = data.team2.sort((a, b) => new Date(a.date) - new Date(b.date));
    
        c.model.team1 = team1;
        c.model.team2 = team2;
      }

      // if(c.model.tournament.isActive){
      
     
      // }
     
  
      c.model.user1.twitchDisplayName = data.playerTeam1;
      c.model.user1.twitchId = data.team1Id;
      c.model.user2.twitchId = data.team2Id;
      c.model.user2.twitchDisplayName = data.playerTeam2;
  
      const cardStats = (userCards) => playingCards.getCardsStats(userCards, c.model.abilities);
  
      const fetchUserData = (team, index) => {
        return new Promise((resolve) => {
            c.getCurrentTwitchInfo(team[index].user[0].twitchId, function(user) {
                if (user) {
                    team[index].user = user; // Update the user object
                } else {
                    // If no user data is found, retain the existing user properties
                    team[index].user = {
                        twitchId: team[index].user[0].twitchId,
                        twitchDisplayName: team[index].user[0].twitchDisplayName,
                        twitchProfileImage: team[index].user[0].twitchProfileImage
                    };
                }
                resolve();
            });
        });
    };
  
      const setupTeam = async (team, userCards, startIndex) => {
          const cards = userCards.map(cardStats);
          for (let i = 0; i < cards.length; i++) {
              const member = team[i + startIndex];
              const memberCards = cards[i];
              if (member.backingId) {
                memberCards.forEach(card => { card.backingId = member.backingId; });
              }
              member.cards.push(...memberCards);
              await fetchUserData(team, i + startIndex);
          }
      };
  
      if (data.type === '2v2') {
          await setupTeam(c.model.team1, [data.user1Cards, data.user2Cards], 0);
          await setupTeam(c.model.team2, [data.user5Cards, data.user6Cards], 0);
      } else if (data.type === '3v3') {
          await setupTeam(c.model.team1, [data.user1Cards, data.user2Cards, data.user3Cards], 0);
          await setupTeam(c.model.team2, [data.user5Cards, data.user6Cards, data.user7Cards], 0);
      } else if (data.type === '4v4') {
          await setupTeam(c.model.team1, [data.user1Cards, data.user2Cards, data.user3Cards, data.user4Cards], 0);
          await setupTeam(c.model.team2, [data.user5Cards, data.user6Cards, data.user7Cards, data.user8Cards], 0);
      }

      setTimeout(function () {
          c.startTournamentBattle();
      }, _STARTBATTLE);
  },
    //Get battling users twitch info
    getTwitchInfo(data) {
      const c = this;

  
      //fakers accounts only 

      // c.model.user1 = data.twitch1DisplayName[0];
      // c.model.user2 = data.twitch2DisplayName[0];
      // setTimeout(function() {
      //   c.startBattle();
      // }, _STARTBATTLE);
  
      twitchAPI.getUsersById([{twitchId: data.user1TwitchId}, {twitchId: data.user2TwitchId}], function(userData) {
  
        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }
  
          if (data.user1TwitchId == user.twitchId) {
            c.model.user1 = user;
          } else if (data.user2TwitchId == user.twitchId) {
            c.model.user2 = user;
          }
          
        }
  
        setTimeout(function() {
          c.startBattle();
        }, _STARTBATTLE);
  
      });
    },
    getCurrentTwitchInfo(data, callback) {
      const c = this;
      twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
        if (userData && userData.length > 0) {
          let user = {
            twitchId: userData[0].id,
            twitchDisplayName: userData[0].display_name,
            twitchProfileImage: userData[0].profile_image_url
          };
          callback(user); // Call the callback with the user data
        } else {
          callback(null); // Call the callback with null if no user data is found
        }
      });
    },
    startTournamentBattle: function () {

      const c = this;
      //c.model.show.battle = true;
      c.showStats();
      setTimeout(function (){
        c.model.show.profile_intro = true;
        setTimeout(function () {
          c.model.show.profile_intro = false;
          c.model.show.users = true;
  
          setTimeout(function () {
            c.model.show.move = true;
  
            setTimeout(function () {
              c.model.show.cards = true;
  
              setTimeout(function () {
                if(c.model.team1.length === 2 &&  c.model.team2.length === 2){
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                }
                else if(c.model.team1.length === 3 &&  c.model.team2.length === 3){
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team1[2].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                  c.flip(c.model.team2[2].cards[0], 0);
                }
                else{
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team1[2].cards[0], 0);
                  c.flip(c.model.team1[3].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                  c.flip(c.model.team2[2].cards[0], 0);
                  c.flip(c.model.team2[3].cards[0], 0);
                }
            
                c.model.audio.flip.play();
  
                //TODO seems like this isn't supposed to be here
                // c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards2, c.model.cards1);
                // c.app  lyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1);
                setTimeout(function () {  
                  //trigger initial abilities
                  if(c.model.team1.length === 2 &&  c.model.team2.length === 2){
                    c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards,c.model.team1[0].index, c.model.team2[0].index );
                    c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index);
                  }
                  else if (c.model.team1.length === 3 &&  c.model.team2.length === 3){
                     c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards, c.model.team1[0].index, c.model.team2[0].index, 0 );
                      c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index, 1);
                      c.teamInitialAbilities(c.model.team1[2].cards, c.model.team2[2].cards,c.model.team1[2].index, c.model.team2[2].index, 2);
                  }
                  else{
                    c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards,c.model.team1[0].index, c.model.team2[0].index );
                    c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index);
                    c.teamInitialAbilities(c.model.team1[2].cards, c.model.team2[2].cards,c.model.team1[2].index, c.model.team2[2].index );
                    c.teamInitialAbilities(c.model.team1[3].cards, c.model.team2[3].cards,c.model.team1[3].index, c.model.team2[3].index );
                
                  }
                  c.startTournamentRound(Math.random());
                }, 1500);
              }, 1000);
            }, 1000);
          }, 3000);
        }, 5000);
      },1000)
    },
    //Start battle by flipping first cards and applying the initial abilities
    startBattle: function() {
      const c = this;

      //c.model.show.battle = true;

      c.showStats();

      // Broadcast battle started event via WebSocket for real-time OBS overlay updates
      c.broadcastBattleStarted();

      setTimeout(function() {
        c.model.show.users = true;

        setTimeout(function() {
          c.model.show.move = true;

          setTimeout(function() {
            c.model.show.cards = true;

            setTimeout(function() {
              c.flip(c.model.cards1[0], 0);
              c.flip(c.model.cards2[0], 0);
              c.model.audio.flip.play();

              //TODO seems like this isn't supposed to be here
              // c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards2, c.model.cards1);
              // c.applyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1);

              setTimeout(function() {
                c.applyInitialAbilities(c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                c.applyInitialAbilities(c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                c.applyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                c.startRound(Math.random());
              }, 1500);
            }, 1000);
          }, 1000);
        }, 1500)
      }, 500)
    },

    teamInitialAbilities(cards1, cards2 , index1, index2, indexOf){
      const c = this;

      c.applyInitialAbilities(
        cards1,
        cards2,
        index1,
        index2,
        indexOf
      );
      c.applyInitialAbilities(
        cards2,
        cards1,
        index2,
        index1,
        indexOf
      );
      c.applyTurnAbiltiy(
        cards1[0],
        cards1,
        cards2,
        index1,
        index2,
        indexOf
      );
      c.applyTurnAbiltiy(
        cards2[0],
        cards2,
        cards1,
        index2,
        index1,
        indexOf
      );
    },
    //Apply abilities for abilities that fire at the beginning of the battle
    applyInitialAbilities: function(cards1, cards2, index1, index2) {
      const c = this;
      for (let card of cards1) {
        try {
          if (card.abilityKey && typeof abilities.initial[`${card.abilityKey}`] === 'function') {
            abilities.initial[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.events);
            c.logEvent(`${card.name} used ${card.ability}!`, 'ability', {
              card: card.name,
              ability: card.ability,
              tier: card.tier
            });
          }
        }
        catch(err) {
          c.logError(`${card.ability} through an error`);
        }
      }

    },
    startTournamentRound(first,second, third, fourth) {

      const c = this;
      if(c.model.team1.length === 2 &&  c.model.team2.length === 2){

          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){
            if(c.model.team2winner.length === 2){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 2){
              c.teamDefeated(2)
            }
            setTimeout(function () {
                c.model.singleMode = false;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.startRound(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
        
        }
      }
      if(c.model.team1.length === 3 &&  c.model.team2.length === 3){

          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){

            if(c.model.team2winner.length === 3){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 3){
              c.teamDefeated(2)
            }
            setTimeout(function () {
                c.model.singleMode = false;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.startRound(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
              if(c.model.team1[2].cards.length > c.model.team1[2].index && c.model.team2[2].cards.length > c.model.team2[2].index){
              c.handleTeamAttack(2, Math.random() );
            }
        
        }
      }
      if(c.model.team1.length === 4 &&  c.model.team2.length === 4){

          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){

            if(c.model.team2winner.length === 4){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 4){
              c.teamDefeated(2)
            }
            setTimeout(function () {
                c.model.singleMode = false;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.startRound(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
              if(c.model.team1[2].cards.length > c.model.team1[2].index && c.model.team2[2].cards.length > c.model.team2[2].index){
              c.handleTeamAttack(2, Math.random() );
            }
              if(c.model.team1[3].cards.length > c.model.team1[3].index && c.model.team2[3].cards.length > c.model.team2[3].index){
              c.handleTeamAttack(3, Math.random() );
            }
        
        }
      }
      
    },
    handleTeamAttack(index, first){
      const c= this;

        if (c.model.team1[index].cards.length > c.model.team1[index].index && c.model.team2[index].cards.length > c.model.team2[index].index) {
          
        let totalMoveCount = 0;
        let moveCount1 = c.getAttachCount(c.model.team1[index].cards[c.model.team1[index].index]);
        let moveCount2 = c.getAttachCount(c.model.team2[index].cards[c.model.team2[index].index]);
        totalMoveCount += moveCount1;
        totalMoveCount += moveCount2;


        if( first < .5){
          for (let i = 0; i < moveCount1; i++) {
            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.team1[index].cards[c.model.team1[index].index],
                  c.model.team2[index].cards[c.model.team2[index].index],
                  c.model.team1[index].cards,
                  c.model.team2[index].cards,
                  c.model.team1[index].index,
                  c.model.team2[index].index,
                  1
                )
              ) {
                c.model.team2[index].index += 1;
                c.flip(c.model.team2[index].cards[c.model.team2[index].index]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team2[index].cards,
                    c.model.team1[index].cards,
                    c.model.team2[index].index,
                    c.model.team1[index].index,
                    2
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }
          setTimeout(function () {
            for (let i = 0; i < moveCount2; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team2[index].cards,
                    c.model.team1[index].cards,
                    c.model.team2[index].index,
                    c.model.team1[index].index,
                    2
                  )
                ) {
                  c.model.team1[index].index += 1;
                  c.flip(c.model.team1[index].cards[c.model.team1[index].index]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.team1[index].cards[c.model.team1[index].index],
                      c.model.team1[index].cards,
                      c.model.team2[index].cards,
                      c.model.team1[index].index,
                      c.model.team2[index].index
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount1);
        }
        else {
          for (let i = 0; i < moveCount2; i++) {

            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.team2[index].cards[c.model.team2[index].index],
                  c.model.team1[index].cards[c.model.team1[index].index],
                  c.model.team2[index].cards,
                  c.model.team1[index].cards,
                  c.model.team2[index].index,
                  c.model.team1[index].index,
                  2
                )
              ) {
                c.model.team1[index].index += 1;
                c.flip(c.model.team1[index].cards[c.model.team1[index].index]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team1[index].cards,
                    c.model.team2[index].cards,
                    c.model.team1[index].index,
                    c.model.team2[index].index
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function () {
            for (let i = 0; i < moveCount1; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team1[index].cards,
                    c.model.team2[index].cards,
                    c.model.team1[index].index,
                    c.model.team2[index].index,
                    1
                  )
                ) {
                  c.model.team2[index].index += 1;
                  c.flip(c.model.team2[index].cards[c.model.team2[index].index]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.team2[index].cards[c.model.team2[index].index],
                      c.model.team2[index].cards,
                      c.model.team1[index].cards,
                      c.model.team2[index].index,
                      c.model.team1[index].index,
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount2);
        }

        setTimeout(function () {
          c.handleTeamAttack(
            index,
            first
          );
        }, 2500 * (totalMoveCount - 1));

        return
      
      }
      else{
  
        if (c.model.team1[index].index == c.model.team1[index].cards.length) {
          // console.log('talo player 1')
          // c.model.team2winner.unshift(c.model.team2[index]);
          // for(i = 0; i < c.model.team2[index].cards.length; i++){
          //   const hp = c.model.team2[index].cards[i].hp;
          //     if (hp > 0) {
          //       c.model.cards2.unshift(c.model.team2[index].cards[i])
          //   }
          // }
      
            c.handleWinner(c.model.team2, index, false);
        }
      
        if (c.model.team2[index].index == c.model.team2[index].cards.length) {
            c.handleWinner(c.model.team1, index, true);
        }
      
      }

      if((c.model.tournament.battleOption !== 'single')){
        if(c.model.team1.length == c.model.team1winner.concat(c.model.team2winner).length){
          let $removeContainer= $(`#first_round`);

          $removeContainer.addClass('fade-out');
          setTimeout(function(){
              $removeContainer.remove()
              c.model.singleMode = true;
              c.model.show.profile_intro = true;
              c.startBattle();
          },2000)
     
        }
      }



    },
  async startRound(first) {
  const c = this;

  if (c.model.cards1.length > c.model.index1 && c.model.cards2.length > c.model.index2) {
    let moveCount1 = c.getAttachCount(c.model.cards1[c.model.index1]);
    let moveCount2 = c.getAttachCount(c.model.cards2[c.model.index2]);
    let totalMoveCount = moveCount1 + moveCount2;

    // Hook: Start-of-turn trait processing (burning, withered, frozen announce)
    if (window.traits) {
      const _sCard1 = c.model.cards1[c.model.index1];
      const _sCard2 = c.model.cards2[c.model.index2];
      if (_sCard1) { traits.processStartOfTurn(_sCard1, c.model.cards2, c.model.index2, c.logEvent.bind(c)); }
      if (_sCard2) { traits.processStartOfTurn(_sCard2, c.model.cards1, c.model.index1, c.logEvent.bind(c)); }
    }

    if (first < .5) {

      // Card 1 attacks first
      for (let i = 0; i < moveCount1; i++) {
        if (c.model.cards2.length <= c.model.index2) break;

        const defeated = await c.attemptAttack(
          c.model.cards1[c.model.index1],
          c.model.cards2[c.model.index2],
          c.model.cards1, c.model.cards2,
          c.model.index1, c.model.index2
        );

        if (defeated) {
          c.model.index2 += 1;
          if (c.model.cards2[c.model.index2]) {
            c.flip(c.model.cards2[c.model.index2], 0);
            await c.wait(_FLIP);
            c.applyTurnAbiltiy(c.model.cards2[c.model.index2], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
          }
          break; // ✅ stop this card's remaining attacks, card is dead
        }
      }

      await c.wait(500);

      // Card 2 attacks
      for (let i = 0; i < moveCount2; i++) {
        if (c.model.cards1.length <= c.model.index1) break;

        const defeated = await c.attemptAttack(
          c.model.cards2[c.model.index2],
          c.model.cards1[c.model.index1],
          c.model.cards2, c.model.cards1,
          c.model.index2, c.model.index1
        );

        if (defeated) {
          c.model.index1 += 1;
          if (c.model.cards1[c.model.index1]) {
            c.flip(c.model.cards1[c.model.index1], 0);
            await c.wait(_FLIP);
            c.applyTurnAbiltiy(c.model.cards1[c.model.index1], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
          }
          break;
        }
      }

    } else {

      // Card 2 attacks first
      for (let i = 0; i < moveCount2; i++) {
        if (c.model.cards1.length <= c.model.index1) break;

        const defeated = await c.attemptAttack(
          c.model.cards2[c.model.index2],
          c.model.cards1[c.model.index1],
          c.model.cards2, c.model.cards1,
          c.model.index2, c.model.index1
        );

        if (defeated) {
          c.model.index1 += 1;
          if (c.model.cards1[c.model.index1]) {
            c.flip(c.model.cards1[c.model.index1], 0);
            await c.wait(_FLIP);
            c.applyTurnAbiltiy(c.model.cards1[c.model.index1], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
          }
          break;
        }
      }

      await c.wait(500);

      // Card 1 attacks
      for (let i = 0; i < moveCount1; i++) {
        if (c.model.cards2.length <= c.model.index2) break;

        const defeated = await c.attemptAttack(
          c.model.cards1[c.model.index1],
          c.model.cards2[c.model.index2],
          c.model.cards1, c.model.cards2,
          c.model.index1, c.model.index2
        );

        if (defeated) {
          c.model.index2 += 1;
          if (c.model.cards2[c.model.index2]) {
            c.flip(c.model.cards2[c.model.index2], 0);
            await c.wait(_FLIP);
            c.applyTurnAbiltiy(c.model.cards2[c.model.index2], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
          }
          break;
        }
      }
    }

    // Pause between rounds
    await c.wait(800);

        setTimeout(function() {
          // Hook 5: End-of-turn trait processing + duration tick
          if (window.traits) {
            const _eCard1 = c.model.cards1[c.model.index1];
            const _eCard2 = c.model.cards2[c.model.index2];
            if (_eCard1) { traits.processEndOfTurn(_eCard1, c.logEvent.bind(c)); traits.tick(_eCard1); }
            if (_eCard2) { traits.processEndOfTurn(_eCard2, c.logEvent.bind(c)); traits.tick(_eCard2); }
          }
          c.startRound(Math.random());
        }, 2500 * (totalMoveCount - 1));

        return;
    
      }

      if (c.model.index2 == c.model.cards2.length) {
        // c.getQuest(c.model.cards2, 2);
        if((c.model.team1.length > 1)){
          c.teamDefeated(1)
          return;
        }
        else{
          c.playerDefeated(2); 
          return;
        }
    

      } else {
        // c.getQuest(c.model.cards2, 2);
        if((c.model.team1.length > 1)){
          c.teamDefeated(2)
          return;
        }
        else{
          c.playerDefeated(1); 
          return;
        }
        
      }
    },
    applyTurnAbiltiy(card, cards1, cards2, index1, index2) {
      const c = this;
      try {
        if (card && card.abilityKey && typeof abilities.turn[`${card.abilityKey}`] === 'function') {
          abilities.turn[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.events);
          c.logEvent(`${card.name} used ${card.ability}!`, 'ability', {
            tier: card.tier
          });
        }
      }
      catch(err) {
        c.logError(`${card.ability} through an error`);
      }

    },
    /**
     * Broadcast individual attack event via WebSocket
     */
    broadcastAttack(attackData) {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          const message = {
            message: 'battleAttack',
            channelId: c.model.currentUserId,
            battleId: c.model.id,
            attackerCard: {
              id: attackData.attacker.id,
              name: attackData.attacker.name,
              hp: attackData.attacker.hp,
              attack: attackData.attacker.attack,
              image: attackData.attacker.image,
              currentStamina: attackData.attacker.currentStamina,
              currentMana: attackData.attacker.currentMana,
              maxStamina: attackData.attacker.maxStamina,
              maxMana: attackData.attacker.maxMana
            },
            defenderCard: {
              id: attackData.defender.id,
              name: attackData.defender.name,
              hp: attackData.defender.hp,
              hpAfter: attackData.hpAfter,
              image: attackData.defender.image,
              currentStamina: attackData.defender.currentStamina,
              currentMana: attackData.defender.currentMana,
              maxStamina: attackData.defender.maxStamina,
              maxMana: attackData.defender.maxMana
            },
            damage: attackData.damage,
            critical: attackData.critical,
            missed: attackData.missed,
            defenderDefeated: attackData.defenderDefeated,
            attackerIndex: attackData.attackerIndex,
            defenderIndex: attackData.defenderIndex,
            attackerResourceChanges: attackData.attackerResourceChanges || null,
            timestamp: new Date().toLocaleString()
          };

          console.log('[BattleArena] Broadcasting attack:', message);
          ws.send(JSON.stringify(message));
          ws.close();
        };

        ws.onerror = (error) => {
          console.log('WebSocket error for attack broadcast:', error);
        };
      } catch (error) {
        console.log('WebSocket unavailable for attack broadcast:', error);
      }
    },
    // Check if card can attack (has enough resources)
    canAttack(card) {
      // Need at least 10 stamina OR 10 mana to attack
      return card.currentStamina >= 10 || card.currentMana >= 10;
    },

    // Regenerate both resources after attacking
    regenerateResource(card) {
      const c = this;
      // Regenerate both Stamina and Mana after each attack
      // Percentage-based: 6% of max per turn (creates net resource loss over time)
      const previousStamina = card.currentStamina;
      const previousMana = card.currentMana;

      // Calculate regeneration: 6% of max, minimum 5 to ensure some recovery
      const staminaRegenMult = (card._staminaRegenMult !== undefined) ? card._staminaRegenMult : 1;
      const staminaRegen = Math.max(1, Math.round((card.maxStamina || 100) * 0.06 * staminaRegenMult));
      const manaRegen = Math.max(5, Math.round((card.maxMana || 100) * 0.06));

      // Use Vue.set to ensure reactivity
      const newStamina = Math.min(card.maxStamina, (card.currentStamina || 0) + staminaRegen);
      const newMana = Math.min(card.maxMana, (card.currentMana || 0) + manaRegen);
      
      c.$set(card, 'currentStamina', newStamina);
      c.$set(card, 'currentMana', newMana);

      // Maw — Void Leech: any regen (stamina or mana) drains a flat 500 HP
      if (card._mawRegenDrain && (newStamina > previousStamina || newMana > previousMana)) {
        card.hp = Math.max(0, card.hp - 500);
        if (window.effects) { effects.add(card, ['shakeY']); }
        c.logEvent(`Void Leech: ${card.name}'s resource regeneration drained 500 HP`, 'ability', { cardId: card.id });
      }

      // Negan — Lucille: 400 damage per every 10 stamina regenerated (accumulates across turns)
      if (card._neganStaminaBurn && newStamina > previousStamina) {
        const staminaGained = newStamina - previousStamina;
        card._neganStaminaAccum = (card._neganStaminaAccum || 0) + staminaGained;
        const thresholds = Math.floor(card._neganStaminaAccum / 10);
        card._neganStaminaAccum = card._neganStaminaAccum % 10;
        if (thresholds > 0) {
          const lucilleDamage = thresholds * 400;
          card.hp = Math.max(0, card.hp - lucilleDamage);
          if (window.effects) { effects.add(card, ['shakeY']); }
          c.logEvent(`Lucille: ${card.name} regenerated stamina — took ${lucilleDamage} damage (${thresholds}×400)`, 'ability', { cardId: card.id, damage: lucilleDamage });
        }
      }

      // Force Vue to update the view
      c.$nextTick(() => {
        // Trigger regeneration animation if resources were restored
        if (newStamina > previousStamina || newMana > previousMana) {
          c.animateResourceRegeneration(card);
          c.updateResourceBarClasses(card);
        }
      });
    },

    // Animate resource depletion when card uses resources
    animateResourceDepletion(card) {
      const $card = $(`#${card.id}`);
      const $staminaFill = $card.find('.stamina-fill');
      const $manaFill = $card.find('.mana-fill');
      const $hpFill = $card.find('.hp-fill');
      const $resourceBars = $card.find('.resource-bars');

      // Add depletion animation class
      $staminaFill.addClass('depleting');
      $manaFill.addClass('depleting');
      if ($hpFill.length) {
        $hpFill.addClass('depleting');
      }

      // Add shake effect to the entire resource bar container for extra visibility
      $resourceBars.addClass('shake-effect');

      // Remove after animation completes
      setTimeout(() => {
        $staminaFill.removeClass('depleting');
        $manaFill.removeClass('depleting');
        if ($hpFill.length) {
          $hpFill.removeClass('depleting');
        }
        $resourceBars.removeClass('shake-effect');
      }, 800);
    },

    // Animate resource regeneration
    animateResourceRegeneration(card) {
      const $card = $(`#${card.id}`);
      const $staminaFill = $card.find('.stamina-fill');
      const $manaFill = $card.find('.mana-fill');

      // Add regeneration animation class
      $staminaFill.addClass('regenerating');
      $manaFill.addClass('regenerating');

      // Remove after animation completes
      setTimeout(() => {
        $staminaFill.removeClass('regenerating');
        $manaFill.removeClass('regenerating');
      }, 1000);
    },

    // Update resource bar classes based on current levels
    updateResourceBarClasses(card) {
      const $card = $(`#${card.id}`);
      const $staminaFill = $card.find('.stamina-fill');
      const $manaFill = $card.find('.mana-fill');

      // Calculate resource percentages
      const staminaPercent = (card.currentStamina || 0) / (card.maxStamina || 100);
      const manaPercent = (card.currentMana || 0) / (card.maxMana || 100);

      // Add/remove 'low' class for pulsing effect when resources are below 30%
      if (staminaPercent < 0.3) {
        $staminaFill.addClass('low');
      } else {
        $staminaFill.removeClass('low');
      }

      if (manaPercent < 0.3) {
        $manaFill.addClass('low');
      } else {
        $manaFill.removeClass('low');
      }
    },
    // Simple reusable wait/sleep helper
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Scan all alive cards in both teams and fire any registered passive abilities.
    // Called at the top of attemptAttack so it runs every turn, both sides.
    processPassiveAbilities(cards1, cards2, index1, index2) {
      if (!window.abilities || !abilities.passive) { return; }
      const c = this;

      const logFn = c.logEvent.bind(c);
      const scanTeam = (team, opposingTeam, opposingIndex) => {
        for (let i = 0; i < team.length; i++) {
          if (!team[i] || team[i].hp <= 0) { continue; }
          if (typeof abilities.passive[`${team[i].abilityKey}`] === 'function') {
            try {
              abilities.passive[`${team[i].abilityKey}`](team[i], i, team, opposingTeam, opposingIndex, c.model.events, logFn);
            } catch(err) {
              // passive errors are silent — they must not interrupt the battle
            }
          }
        }
      };

      scanTeam(cards1, cards2, index2);
      scanTeam(cards2, cards1, index1);
    },

   async attemptAttack(card1, card2, cards1, cards2, index1, index2) {
  const c = this;

  if (!card1 || !card2) return false;

  // Passive abilities — scan all alive cards in both teams before every attack.
  // This runs regardless of whose turn it is, enabling always-on aura effects.
  c.processPassiveAbilities(cards1, cards2, index1, index2);

      if (card1.turnSkips > 0) {
        card1.turnSkips -= 1;
        c.saveEvent({cardId: card1.id, skipped: true});
        c.logEvent(`${card1.name}'s turn was skipped`, 'info', {
          tier: card1.tier
        });
        return false;
      }

      // Hook 2: Check if traits block this card from acting (Frozen)
      if (window.traits && traits.isBlocked(card1)) {
        c.logEvent(`${card1.name} is Frozen and cannot act!`, 'skip', { tier: card1.tier });
        if (typeof effects !== 'undefined') { effects.add(card1, ['blur'], 800); }
        return false;
      }
  if (card1.turnSkips > 0) {
    card1.turnSkips -= 1;
    c.saveEvent({cardId: card1.id, skipped: true});
    c.logEvent(`${card1.name}'s turn was skipped`, 'info', { tier: card1.tier });
    return false;
  }

  const initialHp = card1.hp;
  const initialStamina = card1.currentStamina || 0;
  const initialMana = card1.currentMana || 0;

  const pAtk = Number(card1.pAtk) || Number(card1.attack) || 0;
  const mAtk = Number(card1.mAtk) || 0;

  const staminaCost = pAtk > 0 ? Math.max(8, Math.min(20, Math.round(pAtk * 0.12))) : 0;
  const manaCost = mAtk > 0 ? Math.max(8, Math.min(20, Math.round(mAtk * 0.12))) : 0;

  const hasStamina = card1.currentStamina >= staminaCost;
  const hasMana = card1.currentMana >= manaCost;

  card1._hasStaminaForAttack = hasStamina;
  card1._hasManaForAttack = hasMana;

  // Pinch — Endurance Protocol: armor below 60% of base → physical attacks cost no stamina
  if (card1._pinchStaminaFree && pAtk > 0) {
    card1._hasStaminaForAttack = true; // ensure full physical damage even with 0 stamina
  }

  let actualStaminaDeduction = 0;
  let actualManaDeduction = 0;

  if (hasStamina && pAtk > 0 && !card1._pinchStaminaFree) {
    if (card1._throttleStaminaImmune) {
      card1._throttleStaminaBlockedThisTick = true;
      // stamina cost blocked — no deduction
    } else {
      actualStaminaDeduction = Math.min(staminaCost, card1.currentStamina);
      c.$set(card1, 'currentStamina', Math.max(0, card1.currentStamina - staminaCost));
    }
  }
  if (hasMana && mAtk > 0) {
    actualManaDeduction = Math.min(manaCost, card1.currentMana);
    c.$set(card1, 'currentMana', Math.max(0, card1.currentMana - manaCost));
  }

      // Trait — Overheated: extra +5 resource drain per attack
      if (window.traits && traits.getExtraResourceCost(card1) > 0) {
        const overExtra = traits.getExtraResourceCost(card1);
        const drainedTypes = [];
        const delayA = Math.floor(Math.random() * 300);
        const delayB = Math.floor(Math.random() * 300);
        if (pAtk > 0) {
          if (card1._throttleStaminaImmune) {
            card1._throttleStaminaBlockedThisTick = true;
          } else {
            c.$set(card1, 'currentStamina', Math.max(0, (card1.currentStamina || 0) - overExtra));
            drainedTypes.push(`${overExtra} stamina`);
            if (typeof window.battleUI !== 'undefined') { window.battleUI.showResourceLost(card1, overExtra, 'stamina', delayA); }
          }
        }
        if (mAtk > 0) {
          c.$set(card1, 'currentMana', Math.max(0, (card1.currentMana || 0) - overExtra));
          drainedTypes.push(`${overExtra} mana`);
          if (typeof window.battleUI !== 'undefined') { window.battleUI.showResourceLost(card1, overExtra, 'mana', delayB); }
        }
        if (drainedTypes.length > 0) {
          c.logEvent(`${card1.name} is Overheated — drained extra ${drainedTypes.join(' and ')}!`, 'damage', { tier: card1.tier });
        }
      }

  const staminaAfterDeduction = card1.currentStamina || 0;
  const manaAfterDeduction = card1.currentMana || 0;

  c.$nextTick(() => {
    c.animateResourceDepletion(card1);
    c.updateResourceBarClasses(card1);
  });

  c.model.audio.move.play();

  try {
    if (typeof abilities.move[`${card1.abilityKey}`] === 'function') {
      abilities.move[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.events, c.logEvent.bind(c));
      c.logEvent(`${card1.name} used ${card1.ability}!`, 'ability', { card: card1.name, ability: card1.ability, tier: card1.tier });
    }
  } catch(err) {
    c.logError(`${card1.ability} threw an error`);
  }

      // Hook 3a: Trait — Confused (20% chance to self-attack instead of enemy)
      if (window.traits && traits.has(card1, 'confused') && Math.random() < 0.5) {
        const selfDmg = Math.max(1, Math.round((Number(card1.pAtk) || Number(card1.attack) || 0) * 0.5));
        card1.hp = Math.max(0, card1.hp - selfDmg);
        c.logEvent(`${card1.name} attacked itself in confusion for ${selfDmg} damage!`, 'ability', { tier: card1.tier });
        if (typeof effects !== 'undefined') { effects.add(card1, ['jello'], 900); }
        return false;
      }

      // Hook 3b: Trait — Hallucinating (5% chance to attack the next waiting teammate)
      if (window.traits && traits.has(card1, 'hallucinating') && Math.random() < 0.05) {
        const nextAlly = cards1[index1 + 1];
        if (nextAlly) {
          const friendlyDmg = Math.max(1, Math.round((Number(card1.pAtk) || Number(card1.attack) || 0) * 0.5));
          nextAlly.hp = Math.max(0, nextAlly.hp - friendlyDmg);
          c.logEvent(`${card1.name} is hallucinating and attacked ${nextAlly.name} for ${friendlyDmg} damage!`, 'ability', { tier: card1.tier });
          c.flip(nextAlly);
          if (typeof effects !== 'undefined') { effects.add(nextAlly, ['glow-red'], 900); }
          if (typeof window.battleUI !== 'undefined') { window.battleUI.showHpLost(nextAlly, friendlyDmg, 'hallucinating'); }
        } else {
          c.logEvent(`${card1.name} is hallucinating and stumbles — no teammate to swing at!`, 'skip', { tier: card1.tier });
        }
        return false;
      }

      // Hook 3c: Trait — Hacked (20% chance enemy uses your ability against you this turn)
      if (window.traits && traits.has(card1, 'hacked') && Math.random() < 0.2) {
        if (card1.abilityKey && typeof abilities !== 'undefined' && typeof abilities.turn[card1.abilityKey] === 'function') {
          try {
            abilities.turn[card1.abilityKey](cards1, cards1, index1, index1, c.model.events);
            c.logEvent(`${card1.name}'s ability was turned against them!`, 'ability', { tier: card1.tier });
          } catch(e) {}
        }
      }

      // Hook 3d: Trait — On-act bleeding fires when card acts
      if (window.traits) { traits.processOnAct(card1, c.logEvent.bind(c)); }

  // ✅ Wait for VFX to finish before applying damage
  await c.cardAttack(card1);

  let cardHp = card2.hp;
  let missed = false;
  let critical = false;
  let variedDamage = 0;

  if (Math.random() * 100 < Number(card1.accuracy)) {
    const armor = Number(card2.armor) || Number(card2.defence) || 0;
    const ward = Number(card2.ward) || 0;

    let physicalDamage = Math.max(0, pAtk - armor);
    let magicDamage = Math.max(0, mAtk - ward);

        // Trait — Dominated: -20% magic damage output
        if (window.traits) { magicDamage = Math.round(magicDamage * traits.getMagicDamageMult(card1)); }

    if (!card1._hasStaminaForAttack && pAtk > 0) physicalDamage = Math.round(physicalDamage * 0.2);
    if (!card1._hasManaForAttack && mAtk > 0) magicDamage = Math.round(magicDamage * 0.2);

    let baseDamage = physicalDamage + magicDamage || 1;
    const variance = 0.85 + (Math.random() * 0.15);
    let damage = Math.round(baseDamage * variance);

    const critChance = Number(card1.critChance) || Number(card1.criticalChance) || 5;
    const critDamage = Number(card1.critDamage) || 150;

    if (Math.random() * 100 < critChance) {
      critical = true;
      damage = Math.round(damage * (critDamage / 100));
    }

        // Trait — Overheated: blocks critical hits
        if (window.traits && traits.blocksCriticalHit(card1)) { critical = false; }

    variedDamage = damage;
    cardHp -= variedDamage;

    c.logEvent(`${card1.name} attacks ${card2.name}! Total Damage: ${variedDamage}`, 'attack', {
      attacker: card1.name, defender: card2.name, totalDamage: variedDamage,
      physicalDamage, magicDamage, pAtk, armor, mAtk, ward, critical, tier: card1.tier
    });

    c.saveEvent({ cardId: card1.id, damage: variedDamage, critical });
    c.damageTaken(card2, variedDamage, critical, cards1, cards2, index1, index2);

    // Hook: onCrit — fires when attacker lands a confirmed critical hit
    if (critical && window.abilities && typeof abilities.onCrit?.[`${card1.abilityKey}`] === 'function') {
      try {
        abilities.onCrit[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.events, c.logEvent.bind(c));
        c.logEvent(`${card1.name} critical hit triggered ${card1.ability}!`, 'ability', { card: card1.name, ability: card1.ability, tier: card1.tier });
      } catch(err) {
        c.logError(`${card1.ability} onCrit threw an error`);
      }
      // Attacker self-destruct check (e.g. Sacrificial Grenade)
      if (card1.hp <= 0) {
        c.cardDefeated(card1);
        return false;
      }
    }

    // Hook: onHit — fires on the attacker after damage is dealt, with the actual damage amount
    if (window.abilities && window.abilities.onHit && typeof abilities.onHit[`${card1.abilityKey}`] === 'function') {
      try {
        abilities.onHit[`${card1.abilityKey}`](cards1, cards2, index1, index2, variedDamage, critical, c.model.events, c.logEvent.bind(c));
      } catch(err) {
        c.logError(`${card1.ability} onHit threw an error`);
      }
    }

    // Apply innate trait to defender after a successful hit (only once per battle)
    if (window.traits && card1.traitSlug && !card1.traitUsed && card2) {
      const canApply = !['burning', 'poisoned', 'bleeding'].includes(card1.traitSlug) || traits.canApplyDot(card1);
      if (canApply) {
        traits.apply(card2, card1.traitSlug);
        card1.traitUsed = true;
        const _traitLabel = (traits.definitions[card1.traitSlug] && traits.definitions[card1.traitSlug].label) || card1.traitSlug;
        c.logEvent(`${card2.name} is afflicted with ${_traitLabel}!`, 'ability', { tier: card1.tier });
      }
    }
  } else {
    missed = true;
    c.saveEvent({cardId: card1.id, missed: true});
    c.logEvent(`${card1.name} missed their attack against ${card2.name}`, 'miss', {
      attacker: card1.name, defender: card2.name, tier: card1.tier
    });

    // Hook: onMissed — fires on the defender when attacker misses
    if (window.abilities && window.abilities.onMissed && typeof abilities.onMissed[`${card2.abilityKey}`] === 'function') {
      try {
        abilities.onMissed[`${card2.abilityKey}`](cards2, cards1, index2, index1, c.model.events, c.logEvent.bind(c));
      } catch(err) {}
    }

    // Hook: onMiss — fires on the attacker when they miss
    if (window.abilities && window.abilities.onMiss && typeof abilities.onMiss[`${card1.abilityKey}`] === 'function') {
      try {
        abilities.onMiss[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.events, c.logEvent.bind(c));
      } catch(err) {}
    }
  }

  const staminaRegen = Math.max(5, Math.round((card1.maxStamina || 100) * 0.06));
  const manaRegen = Math.max(5, Math.round((card1.maxMana || 100) * 0.06));

  c.regenerateResource(card1);
  c.updateResourceBarClasses(card1);

  const finalHp = card1.hp;
  const finalStamina = card1.currentStamina || 0;
  const finalMana = card1.currentMana || 0;

  const defenderDefeated = cardHp <= 0;

  c.broadcastAttack({
    attacker: card1, defender: card2,
    damage: variedDamage, critical, missed,
    defenderDefeated, hpAfter: Math.max(0, cardHp),
    attackerIndex: index1, defenderIndex: index2,
    attackerResourceChanges: {
      staminaDeduction: actualStaminaDeduction,
      staminaRegen: finalStamina - staminaAfterDeduction,
      manaDeduction: actualManaDeduction,
      manaRegen: finalMana - manaAfterDeduction,
      hpChange: finalHp - initialHp,
      initialHp, finalHp, initialStamina, finalStamina, initialMana, finalMana
    }
  });

  if (defenderDefeated) {
    // Hook: onDefeated — fires on the defender when they are killed
    // excessDamage = damage beyond the defender's remaining HP before this hit
    if (window.abilities && window.abilities.onDefeated && typeof abilities.onDefeated[`${card2.abilityKey}`] === 'function') {
      try {
        const excessDamage = Math.max(0, variedDamage - cardHp);
        abilities.onDefeated[`${card2.abilityKey}`](cards2, cards1, index2, index1, excessDamage, c.model.events, c.logEvent.bind(c));
      } catch(err) {
        c.logError(`${card2.ability} onDefeated threw an error`);
      }
    }
    // Hook: onKill — fires on the attacker when they defeat an opponent
    if (window.abilities && window.abilities.onKill && typeof abilities.onKill[`${card1.abilityKey}`] === 'function') {
      try {
        abilities.onKill[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.events, c.logEvent.bind(c));
      } catch(err) {
        c.logError(`${card1.ability} onKill threw an error`);
      }
    }
    c.cardDefeated(card2);
    return true;
  }

  return false;
},
    cardAttack(card) {
      return new Promise((resolve) => {
        let $card = $(`#${card.id}`).find('.playing-card-wrapper');
        $card.addClass('attack');

        const isPlayer2 = this.model.cards2.some(c => c.id === card.id);
//   <img src="../vfx/laser.gif" alt="attack vfx"></img>
        const vfxSrc = `../vfx/${card.cardId}.webm`;
        console.log('VFX src:', vfxSrc, 'card.id:', card.id);

        const $vfx = $(`
          <div class="attack-vfx-fullscreen ${isPlayer2 ? 'flipped' : ''}">
            <video autoplay muted playsinline src="${vfxSrc}" type="video/webm"></video>
          </div>
        `);

        // Append to the 1st playing card of the opposing (target) side
        const cardsSide = isPlayer2 ? '.cards-1' : '.cards-2';
        const $cardTarget = $(`[data-component="battle-arena"] ${cardsSide} .playing-card-container:nth-child(1)`);
        $cardTarget.append($vfx);

         // DEBUG: pause battle + video at mid-frame to inspect position/layout
        const _vfxDebug = false;
        const videoEl = $vfx.find('video')[0];
        if (_vfxDebug) {
          videoEl.addEventListener('loadedmetadata', function() {
            videoEl.currentTime = videoEl.duration / 5;
            videoEl.pause();
          });
          // Expose resume hook — call window.resumeBattle() in console to continue
          window.resumeBattle = function() {
            $vfx.remove();
            $card.removeClass('attack');
            delete window.resumeBattle;
            resolve();
          };
        } else {
          // Resolve the promise when animation ends (matches your 2s GIF)
          setTimeout(function() {
            $vfx.remove();
            $card.removeClass('attack');
            resolve();
          }, 2000);
        }

        // Resolve the promise when animation ends (matches your 2s GIF)
        // setTimeout(function() {
        //   $vfx.remove();
        //   $card.removeClass('attack');
        //   resolve(); // ✅ signals "animation is done, proceed"
        // }, 2000); // match this to your GIF/WebM duration
      });
    },
    damageTaken(card, damage, critical, cards1, cards2, index1, index2) {
      const c = this;
      let $card = $(`#${card.id}`);

      let $hpLost = $(`<span class="hp-lost">-${damage}</span>`);
      $card.append($hpLost);
      $card.find('.playing-card-wrapper').addClass('-shakeX');

      // Animate HP bar depletion
      const $hpFill = $card.find('.hp-fill');
      const $resourceBars = $card.find('.resource-bars');
      if ($hpFill.length) {
        $hpFill.addClass('depleting');
        $resourceBars.addClass('shake-effect');
      }

      if (critical) {
        $card.find('.playing-card-wrapper').addClass('-flash');
      }

      const criticalText = critical ? ' (CRITICAL HIT!)' : '';
      c.logEvent(`${card.name} took ${damage} damage${criticalText}`, 'damage', {
        tier: card.tier
      });

      setTimeout(function() {
        //So the visual hp on the card doesn't go below 0
        if (card.hp - damage < 0) {
          card.hp = 0;
        } else {
          card.hp -= damage;

          // Hook 4: On-hit trait processing (bleeding on hit, critical breaks Frozen)
          if (window.traits) { traits.processOnHit(card, damage, critical, c.logEvent.bind(c)); }

          try {
            if (typeof abilities.damaged[`${card.abilityKey}`] === 'function') {
              abilities.damaged[`${card.abilityKey}`](cards2, cards1, index2, index1, damage, c.model.events, critical, c.logEvent.bind(c));
              c.logEvent(`${card.name} used ${card.ability}!`, 'ability', {
                tier: card.tier
              });
            }
          }
          catch(err) {
            c.logError(`${card.ability} through an error`);
          }

          // Hook: teamCrit — fires on the card waiting immediately behind the
          // one that just took a critical hit (index2 + 1 in the defender's team).
          if (critical && window.abilities && window.abilities.teamCrit) {
            const supportCard = cards2[index2 + 1];
            if (supportCard && supportCard.hp > 0 && typeof abilities.teamCrit[`${supportCard.abilityKey}`] === 'function') {
              try {
                abilities.teamCrit[`${supportCard.abilityKey}`](cards2, cards1, index2 + 1, index1, c.model.events);
                c.logEvent(`${supportCard.name} reacted to ${card.name} taking a critical hit!`, 'ability', { card: supportCard.name, ability: supportCard.ability, tier: supportCard.tier });
              } catch(err) {
                c.logError(`${supportCard.ability} teamCrit threw an error`);
              }
            }
          }
          
        }

        // Regenerate resources when defending
        // Cards recover resources while being attacked, but only for their attack types
        const cardPAtk = Number(card.pAtk) || Number(card.attack) || 0;
        const cardMAtk = Number(card.mAtk) || 0;

        console.log(`[${card.name} DEFENDING] pAtk: ${cardPAtk}, mAtk: ${cardMAtk}, card.pAtk: ${card.pAtk}, card.attack: ${card.attack}, card.mAtk: ${card.mAtk}`);

        const DEFENSE_REGEN = 8; // Regen amount per hit while defending

        const previousStamina = card.currentStamina;
        const previousMana = card.currentMana;
        let newStamina = card.currentStamina;
        let newMana = card.currentMana;

        // Only regenerate stamina if card has physical attack
        if (cardPAtk > 0) {
          newStamina = Math.min(card.maxStamina, (card.currentStamina || 0) + DEFENSE_REGEN);
          console.log(`[${card.name} DEFENDING] Regenerating stamina: ${card.currentStamina} -> ${newStamina}`);
          c.$set(card, 'currentStamina', newStamina);
        }

        // Only regenerate mana if card has magic attack
        if (cardMAtk > 0) {
          newMana = Math.min(card.maxMana, (card.currentMana || 0) + DEFENSE_REGEN);
          console.log(`[${card.name} DEFENDING] Regenerating mana: ${card.currentMana} -> ${newMana}`);
          c.$set(card, 'currentMana', newMana);
        }

        c.model.audio.hit.play();
        
        $hpLost.addClass('show');
        $card.find('.playing-card-wrapper').removeClass('-shakeX -flash');
        
        // Remove HP bar depletion animation after it completes
        if ($hpFill.length) {
          setTimeout(() => {
            $hpFill.removeClass('depleting');
            $resourceBars.removeClass('shake-effect');
          }, 500);
        }

        // Trigger regeneration animation if resources were restored
        c.$nextTick(() => {
          if (newStamina > previousStamina || newMana > previousMana) {
            c.animateResourceRegeneration(card);
            c.updateResourceBarClasses(card);
          }
        });
      }, 300);

      setTimeout(function() {
        $hpLost.addClass('remove');

        setTimeout(function() {
          $hpLost.remove();
        }, 3000);
      }, 1300);
    },
    cardDefeated(card) {
      let c = this;
      //setTimeout(function() {
        let $card = $(`#${card.id}`);
        $card.addClass('remove');

        setTimeout(function() {
          $card.remove();
        }, 1000);
      //}, 1000);

      c.saveEvent({cardId: card.id, defeated: true});
      c.logEvent(`${card.name} was defeated!`, 'info', {
        tier: card.tier
      });
    },
    handleWinner(team, index, isTeam1) {

      const c = this;

      const winner = isTeam1 ? c.model.team1[index] : c.model.team2[index];
      const loser = isTeam1 ? c.model.team2[index] : c.model.team1[index];
      const $user = $(`[data-id="${loser.user.twitchId}"]`);
      const $playingCardFront = $user.find('.eliminated-icon');
      $playingCardFront.addClass('show');
      const winnerTwitchId = winner.user.twitchId;
      const loserTwitchId = loser.user.twitchId;
      const winnerDisplayName = winner.user.twitchDisplayName;

      if (isTeam1) {
          if (!c.model.team1winner.includes(winner)) {
              c.model.team1winner.unshift(winner);
                // Add cards to the respective model
              for (let i = 0; i < winner.cards.length; i++) {
                const hp = winner.cards[i].hp;
                if (hp > 0) {
                  if (!c.model.cards1.includes(winner.cards)) {
                    c.model.cards1.unshift(winner.cards[i]);
                  }
                }
              }
          }
        
      } else {
          if (!c.model.team2winner.includes(winner)) {
              c.model.team2winner.unshift(winner);
                // Add cards to the respective model
              for (let i = 0; i < winner.cards.length; i++) {
                const hp = winner.cards[i].hp;
                if (hp > 0) {
                  if (!c.model.cards2.includes(winner.cards)) {
                    c.model.cards2.unshift(winner.cards[i]);
                  }
                }
              }
          }
        
      }

      let data = {
          id: winner.id,
          winnerTwitchId: winnerTwitchId,
          loserTwitchId: loserTwitchId,
          events: c.model.events,
          factionId: winner.factionId,
          loserfactionId: loser.factionId,
      };

      if (c.model.isTournamentOpen) {
          data.round = winner.round;
          data.index = winner.bracketIndex;
          data.tournamentId = winner.tournamentId;
          data.bracket = winner.bracket;
          data.twitchDisplayName = winnerDisplayName;
          data.tournamentTeamUsed = winner.tournamentTeamUsed;
          data.playerStat = isTeam1 ? 'player1' : 'player2';
          data.autobattle = c.model.tournament.auto;
      }
      if (c.model.tournament.battleOption === 'single') {
          c.saveBattle(data);
      }
    },
    playerDefeated(player) {
      const c = this;

      c.logEvent(`Player ${player} was defeated!`);

      c.model.battleLoaded = false;
      c.model.show.cards = false;
      c.model.show.users = false;

      const $user = $(`.user.user${player == 1 ? 2 : 1}`).clone();
      $('.winner-user').html('').append($user);
      c.model.show.winner = true;

      c.model.audio.win.play();

      // player parameter is the LOSING player, so winner is the other player
      const winnerPlayer = player == 1 ? 2 : 1;
      const winnerTwitchId = player == 1 ? c.model.user2.twitchId : c.model.user1.twitchId;
      const loserTwitchId = player == 1 ? c.model.user1.twitchId : c.model.user2.twitchId;
      const winnerDisplayName = player == 1 ? c.model.user2.twitchDisplayName : c.model.user1.twitchDisplayName;
      const winnerProfileImage = player == 1 ? c.model.user2.twitchProfileImage : c.model.user1.twitchProfileImage;

      // Broadcast battle winner via WebSocket (send actual winner player number, not the loser)
      c.broadcastBattleWinner(winnerPlayer, winnerTwitchId, winnerDisplayName, winnerProfileImage);

      const winnerCards = player == 1 ? c.model.cards2 : c.model.cards1;
      cardXPService.awardXP({
        twitchId: winnerTwitchId,
        cardIds: winnerCards.map(card => card.id)
      }).catch(console.error);

      let data = {
        id: c.model.id, 
        winnerTwitchId: winnerTwitchId,
        loserTwitchId: loserTwitchId,
        events: c.model.events,
        factionId:  player == 1 ? c.model.user2Faction : c.model.user1Faction,
        loserfactionId:  player == 1 ? c.model.user1Faction : c.model.user2Faction
      };


      if(c.model.tournament){
        const playerStat = player == 1 ? 'player2' : 'player1';
        data.round = c.model.tournamentData.round
        data.index = c.model.tournamentData.index
        data.tournamentId = c.model.tournament.id
        data.bracket = c.model.tournamentData.bracket
        data.twitchDisplayName = winnerDisplayName
        data.tournamentTeamUsed  = c.model.tournamentData.tournamentTeamUsed
        data.playerStat  = playerStat
        data.tournamentId = c.model.tournament.id;
        data.autobattle = c.model.tournament.auto
        data.channelId = utils.cookies.get('user_id');
      }

      setTimeout(function() {
          if (c.model.settings.autobattle && c.model.settings.stealcards.value) {
          c.model.stolenCard = c.stealCard(player == 1 ? c.model.cards1 : c.model.cards2);
          data.stolenCardId = c.model.stolenCard.id;

          setTimeout(function() {
            c.model.show.stolenCard = true;
            c.flip(c.model.stolenCard);

            setTimeout(function() {
              c.model.show.stolenCard = false;
              setTimeout(function() {
                c.saveBattle(data, false);
              }, 500);
            }, 3500);
          }, 1500);
        } else {
          c.saveBattle(data, false);
        }
      }, 3500);
      
    },
    teamDefeated(player) {
      const c = this;
      c.logEvent(`Team ${player} wins!`);

      c.model.battleLoaded = false;
      c.model.show.cards = false;
      c.model.show.profile_intro = false;
      c.model.show.logs = false;

      c.model.show.winner = true;
      const $user = $(`.col.user${player == 1 ? 1 : 2}`).clone();
      $('.winner div').html('').append($user);

      c.model.audio.win.play();

      const teamWinner = player == 1 ? c.model.team1 : c.model.team2;
      const loserTeam = player == 1 ? c.model.team2 : c.model.team1;

      let winnerDisplayName;
      let loserDisplayName;
      let winnerTwitchId;
      let winnerProfileImage;

      if(c.model.user1.twitchDisplayName == '' || c.model.user2.twitchDisplayName == ''){
        winnerDisplayName = player == 1 ? c.model.team1[0].user.twitchId : c.model.team2[0].user.twitchId
        loserDisplayName = player == 1 ? c.model.team2[0].user.twitchId : c.model.team1[0].user.twitchId
        winnerTwitchId = player == 1 ? c.model.team1[0].user.twitchId : c.model.team2[0].user.twitchId;
        winnerProfileImage = player == 1 ? c.model.team1[0].user.twitchProfileImage : c.model.team2[0].user.twitchProfileImage;
      }
      else{
        winnerDisplayName = player == 1 ? c.model.user1.twitchDisplayName : c.model.user2.twitchDisplayName;
        loserDisplayName = player == 1 ? c.model.user2.twitchDisplayName : c.model.user1.twitchDisplayName;
        winnerTwitchId = player == 1 ? c.model.user1.twitchId : c.model.user2.twitchId;
        winnerProfileImage = player == 1 ? c.model.user1.twitchProfileImage : c.model.user2.twitchProfileImage;
      }

      // Broadcast team battle winner via WebSocket to all connected clients
      c.broadcastBattleWinner(player, winnerTwitchId, winnerDisplayName, winnerProfileImage);

      teamWinner.forEach(member => {
        cardXPService.awardXP({
          twitchId: member.user.twitchId,
          cardIds: member.cards.map(card => card.id)
        }).catch(console.error);
      });

      let data = {
        id: c.model.id,
        winnerTwitchId: teamWinner,
        loserDisplayName: loserDisplayName,
        loserTwitchId: loserTeam,
        events: c.model.events,
        factionId:  player == 1 ? c.model.user1Faction : c.model.user2Faction,
        loserfactionId:  player == 1 ? c.model.user2Faction : c.model.user1Faction,
        twitchDisplayName : winnerDisplayName
      };


      if(c.model.streamer1 && c.model.streamer2){
        data.streamerId = player == 1 ? c.model.streamer1 : c.model.streamer2;
      }

      if(c.model.tournament){
        const playerStat = player == 2 ? 'player2' : 'player1';
        data.round = c.model.tournamentData.round
        data.index = c.model.tournamentData.index
        data.tournamentId = c.model.tournament.id
        data.bracket = c.model.tournamentData.bracket
        data.tournamentTeamUsed  = c.model.tournamentData.tournamentTeamUsed
        data.playerStat  = playerStat
        data.teamId = player == 2 ? c.model.user2.twitchId : c.model.user1.twitchId;
        data.tournamentId = c.model.tournament.id;
        data.battleOption = c.model.tournament.battleOption;
        data.autobattle = c.model.tournament.auto;
        data.channelId = utils.cookies.get('user_id');
        data.message = 'battle'
      }

      console.log(data)

      setTimeout(function () {
        c.model.show.winner = false;
        setTimeout(function () {
  
            c.saveBattle(data, true);
      
          }, 1500);
      }, 3500);

        if (c.model.settings.autobattle && c.model.settings.stealcards.value) {
          c.model.stolenCard = c.stealCard(
            player == 1 ? c.model.cards1 : c.model.cards2
          );
          data.stolenCardId = c.model.stolenCard.id;

         
        } else {
          c.saveBattle(data);a
        }

    },
    saveBattle(data, isTeam) {
      const c = this;

      if(isTeam){
        teamBattleService.save(data)
        .then(function (response) {
          c.ws.send(JSON.stringify(data));
          // Broadcast battle reset to all connected clients before reload
          c.broadcastBattleReset();
          setTimeout(function(){
            window.location.reload();
          },5000)
        })
        .catch(function (error) {
          console.log(error);
        })
      }
      else{

        battleService.save(data)
        .then(function (response) {
          
          if(c.model.isTournamentOpen === true){
            data.channelId = utils.cookies.get('user_id');
            c.ws.send(JSON.stringify(data));
            
            if(c.model.team1.length === c.model.team1winner.concat(c.model.team2winner).length){
              // Broadcast battle reset to all connected clients before reload
              c.broadcastBattleReset();
              setTimeout(function(){
                window.location.reload();
              },3000)
            }

            
            if (c.model.index2 == c.model.cards2.length) {
              c.getQuest(c.model.cards1, 1);
                setTimeout(function() {
                },5000)
            } 
            else {
              c.getQuest(c.model.cards2, 2);
              setTimeout(function() {
              },5000)
            }
            
          }
          else{
              data.twitchId = c.model.index2 === c.model.cards2.length ? c.model.user1.twitchId : c.model.user2.twitchId;
              data.channelId = utils.cookies.get('user_id');

              if(c.model.questUser){
                data.status = 'quest';
              }

              if (c.model.index2 == c.model.cards2.length) {
                c.getQuest(c.model.cards1, 1);
              } 
              else {
                c.getQuest(c.model.cards2, 2);
              }

              if(c.model.tournament){
                
              }
    
              c.ws.send(JSON.stringify(data));
          }
          
        })
        .catch(function (error) {
          c.logEvent(error);
        });
      }
    },
    showStats() {
      $('.info').removeClass('is-visible');
      $('.bottom').removeClass('is-hidden');
    },
    saveEvent(data) {
      const c = this;
      data.battleId = c.model.id;
      c.model.events.push(data);
    },
    logEvent(message, type = 'info', meta = {}) {
      const c = this;
      // console.log(message);
      c.model.show.logs = true;
      setTimeout(function() {
        // Create structured log entry
        const logEntry = {
          message: message,
          type: type, // 'attack', 'damage', 'miss', 'skip', 'ability', 'info'
          timestamp: Date.now(),
          tier: meta.tier || null, // Store tier information for styling
        };

        // Merge any additional meta data
        if (meta && Object.keys(meta).length > 0) {
          Object.assign(logEntry, { meta: meta });
        }

        c.model.logs.unshift(logEntry);
        c.model.logs = c.model.logs.slice(0, 20); // Increase to show more consecutive attacks

        // Broadcast log to extensions (backward compatibility - send message string)
        c.broadcastLog(message);
      }, 300);
    },
    logError(message) {
      const c = this;
      logService.save({message: message})
        .then(function (response) { })
        .catch(function (error) { });
    },
    stealCard(cards) {
      const index = Math.floor(Math.random() * cards.length);
      return cards[index];
    },
    getAttachCount(card) {
      const c = this;
      const maxSpeed = 6000;
      const cardSpeed = card.speed;

      if (cardSpeed == maxSpeed) {
        maxSpeed = maxSpeed * 1.2;
      }

      let chance = (cardSpeed / maxSpeed) / 3; 
      chance = Math.round(chance * 100) / 100;

      if (Math.random() < chance) {
        return 2;
      }

      return 1;

    },
    flip(card, timeout = _FLIP) {
      const c = this;
      if (!card) return;
      setTimeout(function() {
        let id = card.id;
        c.$root.$emit(`flip${id}`, id);
        c.model.audio.flip.play();
        c.showStats();

        // Update resource bar classes when card is flipped
        setTimeout(() => {
          c.updateResourceBarClasses(card);
        }, 300); // Wait for flip animation to complete

        // Determine which player's card and broadcast
        let playerIndex = 1;
        if (c.model.cards2 && c.model.cards2.some(c2 => c2.id === card.id)) {
          playerIndex = 2;
        }
        c.broadcastCardFlip(card, playerIndex);
      }, timeout);
    },
    getQuest(cards, player){
      const c = this;

      const data = {
        twitchId : player === 1 ? c.model.user1.twitchId : c.model.user2.twitchId,
        cards : cards
      }

      battleService.getQuest(data)
      .then(function (response) { 
        c.model.questUser = true;
        if(!c.isResponseEmpty(response.data.quests)){
          c.model.questUser = true;
          c.model.audio.reward.play();
          const totalQuests = response.data.quests.length;

          let currentIndex = totalQuests - 1;
          setTimeout(()=>{
            
            c.model.stolenCard = null;
            c.model.questUser = false;
            c.model.show.winner  = false;
            
            setTimeout(function() {
              // Start the interval and store the interval ID
              const intervalId = setInterval(() => {
                const questContainer = document.getElementById(`quest-index-${currentIndex}`);

                // Check if the quest container exists
                if (questContainer) {
                    questContainer.classList.add('remove-battle-quest');

                    // Wait for the fade-out transition to complete before removing
                    setTimeout(() => {
                        questContainer.remove(); 
                        c.model.audio.pop.play();
                    }, 500); 
                    currentIndex--; 
                } else {
                    clearInterval(intervalId); 
                    let $card = $('.reward-completed');
                    $card.addClass('remove-battle-quest');
                    questContainer.remove();
                }
              }, 700); 
            }, 5000);
          
            // Broadcast battle reset to all connected clients before reload
            c.broadcastBattleReset();
            window.location.reload();
          },8000)
          
        
          
        }
        else{
          c.model.questUser = false;
          console.log(c.isResponseEmpty(response.data.quests))
        }
          c.model.questCards = response.data.quests


      })
      .catch(function (error) {
        console.log(error)
        });
    },
    isResponseEmpty(response) {
      const c = this;
    
      if (typeof response !== 'object' || response === null) {
          return true;
      }

    
      const keys = Object.keys(response);

    
      if (keys.length === 0) {
          return true;
      }

    
      for (const key of keys) {
          if (Array.isArray(response[key]) && response[key].length === 0) {
              return true; 
          }
      }
    
      return false;
    },
    // Load viewer's OBS preference from localStorage
    loadObsViewerPreference() {
      const c = this;
      const saved = localStorage.getItem('obsViewerPreference');
      c.model.obsOverlay.viewerPreference = saved || 'all';
      console.log('[battleArena OBS] Loaded viewer preference:', c.model.obsOverlay.viewerPreference);
    },

    // Save viewer's OBS preference to localStorage
    saveObsViewerPreference(preference) {
      const c = this;
      if (!['all', 'mine', 'others'].includes(preference)) {
        console.warn('[battleArena OBS] Invalid preference:', preference);
        return;
      }
      localStorage.setItem('obsViewerPreference', preference);
      c.model.obsOverlay.viewerPreference = preference;
      console.log('[battleArena OBS] Saved viewer preference:', preference);
      c.applyObsFilters();
    },

    // Apply viewer preference filter (single-layer filtering)
    applyObsFilters() {
      const c = this;
      const viewerPreference = c.model.obsOverlay.viewerPreference;
      const currentUserId = c.model.currentUserId;

      // Get raw data
      const rawBattles = c.model.obsOverlay.allBattles;
      const rawPacks = c.model.obsOverlay.allPacks;

      // Apply only viewer's preference filter (single-layer filtering)
      let filteredBattles = c.filterByViewerPreference(rawBattles, viewerPreference, currentUserId, 'battles');
      let filteredPacks = c.filterByViewerPreference(rawPacks, viewerPreference, currentUserId, 'packs');

      // Update display
      c.model.obsOverlay.battles = filteredBattles;
      c.model.obsOverlay.packs = filteredPacks;

      console.log('[battleArena OBS] Applied viewer preference filter - Battles:', filteredBattles.length, 'Packs:', filteredPacks.length);
    },

    // Filter by viewer's preference (single-layer filtering)
    filterByViewerPreference(items, preference, currentUserId, itemType) {
      if (preference === 'mine' && currentUserId) {
        // Show only viewer's own items
        if (itemType === 'battles') {
          return items.filter(item => item.user1_id === currentUserId || item.user2_id === currentUserId);
        } else if (itemType === 'packs') {
          // For packs, check twitchId (the user who opened/owns the pack)
          return items.filter(item => item.twitchId === currentUserId || item.user_id === currentUserId);
        }
      } else if (preference === 'others' && currentUserId) {
        // Show only other users' items
        if (itemType === 'battles') {
          return items.filter(item => item.user1_id !== currentUserId && item.user2_id !== currentUserId);
        } else if (itemType === 'packs') {
          // For packs, exclude those owned by current user
          return items.filter(item => item.twitchId !== currentUserId && item.user_id !== currentUserId);
        }
      }
      return items; // Return all if 'all'
    },

    // OBS Overlay WebSocket Connection
    connectObsWebSocket() {
      const c = this;
      try {
        c.obsWs = new WebSocket(utils.getWsUrl());

        c.obsWs.onopen = () => {
          console.log('[battleArena OBS] WebSocket connected');
          c.model.obsOverlay.connected = true;
        };

        c.obsWs.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);

            // Handle visibility changes
            if (data.message === 'visibilityChanged') {
              console.log('[battleArena OBS] Visibility changed to:', data.newSetting);
              c.model.obsOverlay.overlayVisibility = data.newSetting;

              // Show notification
              const settingText = data.newSetting === 'all' ? '👁️ All Battles/Packs' : '🔒 Only My Battles/Packs';
              c.model.notification = {
                visible: true,
                message: `Stream visibility changed to: ${settingText}`,
                type: 'success'
              };

              // Auto-hide notification after 5 seconds
              setTimeout(() => {
                c.model.notification.visible = false;
              }, 5000);

              // Refresh overlay battles/packs
              c.fetchObsBattlesAndPacks();
            }

            // Handle streamer OBS settings changes (NEW)
            if (data.message === 'obsSettingsChanged') {
              console.log('[battleArena OBS] Streamer OBS settings changed');
              // Reload streamer configuration and re-apply filters
              c.fetchObsStreamerSettings();
            }

            // Handle new battle
            if (data.message === 'battleStarted') {
              console.log('[battleArena OBS] New battle started');
              c.applyObsFilters(); // Use existing filters
            }

            // Handle new pack
            if (data.message === 'packOpened') {
              console.log('[battleArena OBS] New pack opened');
              c.applyObsFilters(); // Use existing filters
            }
          } catch (e) {
            console.error('[battleArena OBS] Error parsing WebSocket message:', e);
          }
        };

        c.obsWs.onerror = (error) => {
          console.log('[battleArena OBS] WebSocket error:', error);
          c.model.obsOverlay.connected = false;
        };

        c.obsWs.onclose = () => {
          console.log('[battleArena OBS] WebSocket disconnected, attempting reconnect...');
          c.model.obsOverlay.connected = false;
          setTimeout(() => c.connectObsWebSocket(), 3000);
        };
      } catch (error) {
        console.log('[battleArena OBS] WebSocket connection failed:', error);
        c.model.obsOverlay.connected = false;
      }
    },
    // Fetch streamer's OBS settings
    fetchObsStreamerSettings() {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      if (!channelId) {
        console.log('[battleArena OBS] No channel ID available for streamer settings');
        return;
      }

      fetch(`/application/api/obs/streamer-settings.php?channelId=${channelId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.success) {
            c.model.obsOverlay.streamerConfig = {
              packVisibility: data.data.packVisibility || 'all',
              battleVisibility: data.data.battleVisibility || 'all'
            };
            console.log('[battleArena OBS] Loaded streamer config:', c.model.obsOverlay.streamerConfig);
            // Re-apply filters with new streamer config
            c.applyObsFilters();
          } else {
            console.log('[battleArena OBS] Failed to load streamer settings:', data.error);
          }
        })
        .catch(error => {
          console.error('[battleArena OBS] Fetch streamer settings error:', error);
        });
    },

    fetchObsBattlesAndPacks() {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      if (!channelId) {
        console.log('[battleArena OBS] No channel ID available');
        return;
      }

      // Fetch both streamer settings and battles/packs in parallel
      Promise.all([
        fetch(`/application/api/obs/streamer-settings.php?channelId=${channelId}`).then(r => r.json()),
        fetch(`/application/api/obs/battles-and-packs.php?channelId=${channelId}`).then(r => r.json())
      ])
        .then(([settingsData, battlesData]) => {
          // Load streamer config
          if (settingsData.success) {
            c.model.obsOverlay.streamerConfig = {
              packVisibility: settingsData.data.packVisibility || 'all',
              battleVisibility: settingsData.data.battleVisibility || 'all'
            };
            console.log('[battleArena OBS] Loaded streamer config:', c.model.obsOverlay.streamerConfig);
          }

          // Load battles and packs (store raw data)
          if (battlesData.success) {
            c.model.obsOverlay.allBattles = battlesData.battles || [];
            c.model.obsOverlay.allPacks = battlesData.packs || [];
            c.model.obsOverlay.overlayVisibility = battlesData.overlay_visibility;
            console.log('[battleArena OBS] Loaded', battlesData.battles.length, 'battles and', battlesData.packs.length, 'packs');

            // Apply filters
            c.applyObsFilters();
          } else {
            console.log('[battleArena OBS] API Error:', battlesData.error);
          }
        })
        .catch(error => {
          console.error('[battleArena OBS] Fetch error:', error);
        });
    },
    toggleObsOverlay() {
      const c = this;
      c.model.obsOverlay.visible = !c.model.obsOverlay.visible;
      c.model.obsOverlay.toggleState = c.model.obsOverlay.visible ? 'on' : 'off';

      console.log('[battleArena OBS] Toggle state:', c.model.obsOverlay.toggleState);
      console.log('[battleArena OBS] Overlay visible:', c.model.obsOverlay.visible);
      console.log('[battleArena OBS] Complete state:', c.model.obsOverlay);

      if (c.model.obsOverlay.visible && c.model.obsOverlay.battles.length === 0) {
        c.fetchObsBattlesAndPacks();
      }
    },
    setObsOverlayMode(mode) {
      const c = this;
      c.model.obsOverlay.mode = mode; // 'modal', 'side', 'bottom', 'fullscreen'
    }
  },

})